import React, { useMemo } from 'react';
import SalesStageView from './sales-stage-view';
import useURLSearchQuery from '../../../../hooks/use-url-for-search-query';
import { useSalesStageAudit } from './use-sales-stage-audit';
import { SalesStageFilters } from '../types';

interface SalesStageSearch {
  [key: string]: string | string[];
  tripMatchId: string;
  partnerId: string;
  assignedAgentId: string;
  stage: string;
  overdue: string;
  actionTaken: string;
  startDate: string;
  dueAt: string;
}

const defaultSearch: SalesStageSearch = {
  tripMatchId: '',
  partnerId: '',
  assignedAgentId: '',
  stage: '',
  overdue: '',
  actionTaken: '',
  startDate: '',
  dueAt: '',
};

const SalesStageContainer: React.FC = () => {
  const [queryValues, updateURLQuery] = useURLSearchQuery<SalesStageSearch>(defaultSearch);

  const {
    tripMatchId,
    partnerId,
    assignedAgentId,
    stage,
    overdue,
    actionTaken,
    startDate,
    dueAt,
  } = queryValues;

  const filters: SalesStageFilters = useMemo(() => ({
    tripMatchId: tripMatchId || undefined,
    partnerId: partnerId || undefined,
    assignedAgentId: assignedAgentId || undefined,
    stage: stage || undefined,
    actionTaken: actionTaken || undefined,
    startDate: startDate || undefined,
    dueAt: dueAt || undefined,
    overdue: overdue || undefined,
  }), [tripMatchId, partnerId, assignedAgentId, stage, overdue, actionTaken, startDate, dueAt]);

  const {
    audits,
    isLoading,
    error,
    hasMore,
    totalHits,
    loadMore,
  } = useSalesStageAudit(filters);

  const handleFilterChange = (name: string, value: unknown) => {
    updateURLQuery({ [name]: String(value ?? '') });
  };

  return (
    <SalesStageView
      audits={audits}
      isLoading={isLoading}
      error={error}
      hasMore={hasMore}
      totalHits={totalHits}
      loadMore={loadMore}
      filters={queryValues}
      onFilterChange={handleFilterChange}
    />
  );
};

export default SalesStageContainer;
